import { Input, Select } from '@shared/UI';
import { mapLookupsToSelectOptions, splitCamelCase } from '@shared/utils';
import { getSelectValue } from '@widgets/AccountsTable/components/AccountsViewDrawer/utils/getSelectValue';
import { booleanOptions } from '@widgets/AccountsTable/components/utils/consts';
import { Dispatch, SetStateAction } from 'react';
import { useLookups } from '@shared/providers/LookupsProvider';

export const renderEditableField = (
    openEdit: boolean,
    fieldName: string,
    keyName: string,
    setOpenEdit: Dispatch<SetStateAction<boolean>>,
    onChange: (keyName: string, value: string) => void,
    value?: string | null,
) => {
    const { lookups } = useLookups();

    const transactionTypeOptions =
        lookups && mapLookupsToSelectOptions('Etna.FundingApi.Client.TransactionType', lookups);

    if (!openEdit) {
        return keyName === 'type'
            ? splitCamelCase(getSelectValue(fieldName, value ? value.toString() : '').toString(), 'every-word')
            : value;
    }

    if (keyName === 'type') {
        return (
            <Select
                currentValue={getSelectValue(keyName, value ? value.toString() : '').toString()}
                onSelect={(value) => {
                    onChange?.(keyName, value);
                    setOpenEdit(false);
                }}
                dropdownPlacement='top-right'
                options={transactionTypeOptions || []}
            />
        );
    }
    if (keyName === 'isReconciled') {
        return (
            <Select
                currentValue={getSelectValue(keyName, value ? value.toString() : '').toString()}
                onSelect={(value) => {
                    onChange?.(keyName, value);
                    setOpenEdit(false);
                }}
                dropdownPlacement='top-right'
                options={booleanOptions || []}
            />
        );
    }
    return (
        <Input
            editable
            value={value?.toString()}
            onChange={(e) => onChange?.(keyName, e.target.value)}
        />
    );
};
